import { useEffect } from 'react'

import { useUnit } from 'effector-react'

import { useDateRangeContext } from '@/components/provider/date-range-provider'
import { $creatorId } from '@/models/creators'

import {
  $isTrackingActivityLoading,
  $trackingActivityStates,
  fetchTrackingActivityStatesFx,
} from '../models/chatter-activity'

export const useChatterTrackingActivityStates = () => {
  const { date: dateRange } = useDateRangeContext()
  const creatorId = useUnit($creatorId)
  const activityStates = useUnit($trackingActivityStates)
  const isLoading = useUnit($isTrackingActivityLoading)

  useEffect(() => {
    if (!creatorId || !dateRange) {
      return
    }

    const from = dateRange.from || new Date()
    const to = dateRange.to || new Date()

    // Initial fetch
    fetchTrackingActivityStatesFx({ creatorId, from, to })

    // Start polling (60 seconds)
    const intervalId = window.setInterval(() => {
      fetchTrackingActivityStatesFx({ creatorId, from, to })
    }, 60 * 1000)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [creatorId, dateRange])

  return {
    activityStates,
    isLoading,
  }
}
